import { render } from "./BrandsPopUpFilter.vue?vue&type=template&id=59ea4c10&scoped=true"
import script from "./BrandsPopUpFilter.vue?vue&type=script&lang=js"
export * from "./BrandsPopUpFilter.vue?vue&type=script&lang=js"

import "./BrandsPopUpFilter.vue?vue&type=style&index=0&id=59ea4c10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ea4c10"],['__file',"src/components/BrandsPopUpFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59ea4c10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59ea4c10', __exports__)) {
    api.reload('59ea4c10', __exports__)
  }
  
  module.hot.accept("./BrandsPopUpFilter.vue?vue&type=template&id=59ea4c10&scoped=true", () => {
    api.rerender('59ea4c10', render)
  })

}


export default __exports__